export class KeyName {
	key: string | null;
	name: string | null;

	constructor({ key, name }: KeyName) {
		this.key = key;
		this.name = name;
	}
}
